var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandoutSavings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130.5,
    height: 88,
    viewBox: "0 0 130.5 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24688",
    "data-name": "Rectangle 24688",
    width: 130.5,
    height: 88,
    transform: "translate(0 0.001)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84686",
    "data-name": "Group 84686",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84685",
    "data-name": "Group 84685",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240207",
    "data-name": "Path 240207",
    d: "M105.7,55.589v6.293a3.484,3.484,0,0,0,3.462,3.506h13.505v2.787a3.17,3.17,0,0,1-3.169,3.146H115V83.974a3.168,3.168,0,0,1-3.167,3.169h-43.4s27.215-3.6,25.867-31.554Z",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240208",
    "data-name": "Path 240208",
    d: "M4.563,64.737,25.17,78.221A10.137,10.137,0,0,0,40.9,70.2l1.19-25.441A10.112,10.112,0,0,0,27.1,35.408L5.3,47.364a10.136,10.136,0,0,0-.739,17.373",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240209",
    "data-name": "Path 240209",
    d: "M56.9,87.211A30.206,30.206,0,1,0,26.7,57v.006A30.206,30.206,0,0,0,56.9,87.211Z",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240210",
    "data-name": "Path 240210",
    d: "M56.9,26.8h7.281a30.206,30.206,0,0,1,0,60.411h-7.19",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240211",
    "data-name": "Path 240211",
    d: "M90.683,71.388h21.732a2.606,2.606,0,0,1,2.607,2.6V84.6a2.607,2.607,0,0,1-2.607,2.607H61.6",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240212",
    "data-name": "Path 240212",
    d: "M94.3,55.589h25.71a2.585,2.585,0,0,1,2.607,2.563V68.8a2.584,2.584,0,0,1-2.583,2.585H90.683",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10879",
    "data-name": "Line 10879",
    x2: 17.058,
    transform: "translate(48.836 45.228)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10880",
    "data-name": "Line 10880",
    x2: 17.058,
    transform: "translate(48.836 52.779)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240213",
    "data-name": "Path 240213",
    d: "M48.814,45.228h4a7.3,7.3,0,1,1,0,14.608H50.229l10.5,13.08",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240214",
    "data-name": "Path 240214",
    d: "M111.113.862a11.236,11.236,0,0,0-6.586,8.271V24.865h7.642L99.629,40.6,87.109,25.09h4.9V14.055S92.21.818,105.246.818Z",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240215",
    "data-name": "Path 240215",
    d: "M118.461.863H105.246A13.238,13.238,0,0,0,92.009,14.1V25.136h-4.9L99.628,40.643l12.54-15.507h-4.922V11.988a11.237,11.237,0,1,1,22.475,0v9.24H114.865V13.516s0-6.428-3.82-7.866",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10881",
    "data-name": "Line 10881",
    y1: 8.566,
    x2: 3.146,
    transform: "translate(68.456 2.728)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240216",
    "data-name": "Path 240216",
    d: "M49.713,16.8l.517-4.382L46.454,11.09,47.78,7l-4.135-.809",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240217",
    "data-name": "Path 240217",
    d: "M32.318,18.437a2.344,2.344,0,1,1-.894.178A2.3,2.3,0,0,1,32.318,18.437Z",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandoutSavings);
export default __webpack_public_path__ + "static/media/standoutSavings.a2fed744ab214b9f373308c582e63357.svg";
export { ForwardRef as ReactComponent };